<template>
	<el-checkbox-group v-model="selectedValues" @change="handleChange">
		<el-checkbox v-for="(option, index) in sortedOptions" :key="option.optionName" :label="index">
			<ellipsis-two-line-tooltip class="option-text-ellipsis" :text="option.optionName" />
		</el-checkbox>
	</el-checkbox-group>
</template>

<script setup>
import { ref, computed } from 'vue';
import EllipsisTwoLineTooltip from '@rebuild/components/custom-fields/EllipsisTwoLineTooltip.vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	}
});

const emits = defineEmits(['update']);

const selectedValues = ref([]);
const initValues = () => {
	const value = props.field?.dynamicFieldValue || '';
	// 字符串类型，按逗号分割
	selectedValues.value = value
		? value
				.split(',')
				.filter(v => v)
				.map(v => parseInt(v))
		: [];
};
initValues();

// 排序后的选项列表
const sortedOptions = computed(() => {
	const options = props.field?.conditionOptionVOList || [];
	return [...options].sort((a, b) => (a.sort || 0) - (b.sort || 0));
});

// 处理选择变化，将数组用逗号拼接成字符串
const handleChange = val => {
	// 将数组用逗号拼接成字符串, 拼接的是选项的索引
	const valueString = Array.isArray(val) ? val.join(',') : '';
	emits('update', valueString);
};
</script>

<style lang="less" scoped>
.option-text-ellipsis {
	max-width: 280px;
	vertical-align: text-top;
}
</style>
